import React from "react";
import { Route } from "react-router-dom";
import ProtectedRoute from "../components/global/ProtectedRoute";

// Pages
import PostCategoriesList from "../pages/blog/categories/PostCategoriesList";
import CreatePostCategory from "../pages/blog/categories/CreatePostCategory";
import EditPostCategory from "../pages/blog/categories/EditPostCategory";

// Pages - Tags
import PostTagsList from "../pages/blog/tags/PostTagsList";
import CreatePostTag from "../pages/blog/tags/CreatePostTag";
import EditPostTag from "../pages/blog/tags/EditPostTag";

// Pages - Posts
import PostsList from "../pages/blog/posts/PostsList";
import CreatePost from "../pages/blog/posts/CreatePost";
import EditPost from "../pages/blog/posts/EditPost";

const blogRoutes = (
    <>
        {/* Blog Posts (Default) */}
        <Route
            path="/blog/posts"
            element={
                <ProtectedRoute permission="blog.manage">
                    <PostsList />
                </ProtectedRoute>
            }
        />
        <Route
            path="/blog/posts/create"
            element={
                <ProtectedRoute permission="blog.manage">
                    <CreatePost />
                </ProtectedRoute>
            }
        />
        <Route
            path="/blog/posts/:id/edit"
            element={
                <ProtectedRoute permission="blog.manage">
                    <EditPost />
                </ProtectedRoute>
            }
        />

        {/* Blog Categories */}
        <Route
            path="/blog/categories"
            element={
                <ProtectedRoute permission="blog.manage">
                    <PostCategoriesList />
                </ProtectedRoute>
            }
        />
        <Route
            path="/blog/categories/create"
            element={
                <ProtectedRoute permission="blog.manage">
                    <CreatePostCategory />
                </ProtectedRoute>
            }
        />
        <Route
            path="/blog/categories/:id/edit"
            element={
                <ProtectedRoute permission="blog.manage">
                    <EditPostCategory />
                </ProtectedRoute>
            }
        />

        {/* Blog Tags */}
        <Route
            path="/blog/tags"
            element={
                <ProtectedRoute permission="blog.manage">
                    <PostTagsList />
                </ProtectedRoute>
            }
        />
        <Route
            path="/blog/tags/create"
            element={
                <ProtectedRoute permission="blog.manage">
                    <CreatePostTag />
                </ProtectedRoute>
            }
        />
        <Route
            path="/blog/tags/:id/edit"
            element={
                <ProtectedRoute permission="blog.manage">
                    <EditPostTag />
                </ProtectedRoute>
            }
        />
    </>
);

export default blogRoutes;
